<div id="searchoption" class="panel-collapse">
	<div class="panel-body">
		<form class="form-horizontal">
			<div class="form-group">
				<label class="col-sm-4 control-label">Add Points</label>
				<div class="col-sm-8 col-md-8 col-lg-6">
					<select class="form-control" name="PointsItemID" (ngModelChange)="onPointsItemChange($event)" [(ngModel)]="SelectedPointsItemID">
						<option value="" style="display: none"></option>
						<option *ngFor="let p of pointsItemList" [ngValue]="p.PointsItemID" (change)="changePoint(p.PointsItemValue)">
							{{ p.PointsItemDesc }} ({{ p.PointsItemValue }}
							Points)
						</option>
					</select>
					<br />
					<div *ngIf="erroMessage" class="alert alert-danger box-msg" role="alert">
						{{ erroMessage }}
					</div>
					<div *ngIf="saving" class="warning box-msg" role="warning">Processing. Please wait...</div>
					<td>
						<button
							type="button"
							class="btn btn-primary"
							[disabled]="saving"
							(click)="submitClick()"
							href="
  javascript:void(0); "
						>
							Submit
						</button>
						<button type="button" class="btn btn-danger" (click)="cancelClick()" href="javascript:void(0);">Cancel</button>
					</td>
				</div>
			</div>
		</form>
	</div>
</div>
